import axios from "axios";

import { apiClient } from "@src/api/api";

if (!import.meta.env.VITE_AI_URL) {
  throw new Error(
    "VITE_AI_URL is not defined. Please ensure the correct .env file is loaded for your environment (e.g., .env.prod, .env.dev.dev, .env.dev.local)."
  );
}

const aiApiClient = axios.create({
  baseURL: import.meta.env.VITE_AI_URL,
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
});

aiApiClient.interceptors.request = apiClient.interceptors.request;

export { aiApiClient };
